const tooltip = "_tooltip_1pslb_17";
const invisible = "_invisible_1pslb_30";
const caption = "_caption_1pslb_37";
const arrow = "_arrow_1pslb_42";
const styles = {
  tooltip,
  invisible,
  caption,
  arrow
};
export {
  arrow,
  caption,
  styles as default,
  invisible,
  tooltip
};
//# sourceMappingURL=Tooltip.module.css.js.map
